// 1px === 0.07

const style = () => ({
  container: ({ size }) => ({
    lineHeight: '1.2',
    padding: `${size(3.5)} ${size(4)} 0`,
    display: 'flex',
    flexDirection: 'column'
  }),
  title: ({ size }) => ({
    margin: `0 0 ${size(1)}`
  })
})

export default style
